import { useEffect, useState } from "react";
import {
  MaterialReactTable,
  createMRTColumnHelper,
  useMaterialReactTable,
} from "material-react-table";
import {
  Box,
  Button,
  IconButton,
  Link,
  ThemeProvider,
  Tooltip,
  createTheme,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { mkConfig, generateCsv, download } from "export-to-csv";

// import { NotificationIcon } from "react-autoql";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import MonthYearPicker from "../../pages/partnerInvoice/MonthYearPicker";
import ToastComponent from "./ToastComponent";
import { useMediaQuery, useTheme } from "@mui/material";
import { useSelector } from "react-redux";

const csvConfig = mkConfig({
  fieldSeparator: ",",
  decimalSeparator: ".",
  useKeysAsHeaders: true,
});

const NotificationTable = ({
  columns,
  data,
  showRowAction = false,
  DataForExportAll,
  showMonthYearPicker = false,
  onMonthYearChange,
  loading = false,
  permissionKey,
}) => {
  // this is only for month and year selector in partner Invoice
  const handleMonthYearChange = (value) => {
    if (onMonthYearChange) {
      onMonthYearChange(value);
    }
  };
  // end

  if (!data) {
    data = [];
  }
  if (!DataForExportAll) {
    DataForExportAll = data;
  }

  const sanitizeDataForCSV = (rows) => {
    return rows.map((row) => {
      const sanitizedRow = {};
      Object.entries(row).forEach(([key, value]) => {
        if (
          typeof value === "object" &&
          value !== null &&
          !Array.isArray(value) &&
          !(value instanceof Date)
        ) {
          sanitizedRow[key] = JSON.stringify(value);
        } else if (Array.isArray(value)) {
          sanitizedRow[key] = value.join(", ");
        } else {
          sanitizedRow[key] = value;
        }
      });
      return sanitizedRow;
    });
  };

  //-------------logic for show export all data----------

  const rolePermissions = useSelector((state) => state.login.login.role);
  // console.log("[[[[[[[[[[[[]]]]]]]]]]]]]]]]]]]]]]]----rolepermision------", rolePermissions)
  const canExport = rolePermissions?.[permissionKey]?.export === 1;

  // console.log("=++++++++++", canExport)

  //-------------------$$----------------------------------
  const handleExportRows = (rows) => {
    const rawData = rows.map((row) => row.original);
    const cleanData = sanitizeDataForCSV(rawData);
    const csv = generateCsv(csvConfig)(cleanData);
    download(csvConfig)(csv);
  };

  const handleExportData = () => {
    const cleanData = sanitizeDataForCSV(DataForExportAll);
    const csv = generateCsv(csvConfig)(cleanData);
    download(csvConfig)(csv);
  };

  // const handleExportRows = (rows) => {
  //   const rowData = rows.map((row) => row.original);
  //   const csv = generateCsv(csvConfig)(rowData);
  //   download(csvConfig)(csv);
  // };

  // const handleExportData = () => {
  //   // const csv = generateCsv(csvConfig)(data);
  //   const csv = generateCsv(csvConfig)(DataForExportAll);
  //   download(csvConfig)(csv);
  // };

  const table = useMaterialReactTable({
    columns,
    data,
    state: {
      isLoading: loading, // <--- Use this built-in prop for loading state
    },

    initialState: { density: "compact" },
    enableRowSelection: true,
    columnFilterDisplayMode: "popover",
    paginationDisplayMode: "pages",
    positionToolbarAlertBanner: "bottom",
    // enableRowActions: true,
    enableRowActions: showRowAction,
    positionActionsColumn: "last",
    enableGlobalFilter: true,
    maxSize: 100,

    muiTableHeadCellProps: {
      sx: () => ({
        background: "#DCDAFF",
        fontWeight: "normal",
      }),
    },
    // renderRowActions: ({ cell, row, table }) => [
    //   // Add your row actions here
    // ],

    renderRowActions: ({ cell, row, table }) => [
      <>
        <Box display="flex" flexDirection="row" alignItems="center">
          <Tooltip title="Edit User">
            <IconButton>
              {/* <IconButton onClick={() => handleOpen(row.original)}> */}
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton>
              {/* <IconButton onClick={() => handleBlockUser(row.original)}> */}
              <Delete />
            </IconButton>
          </Tooltip>
        </Box>
      </>,
    ],
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          padding: "8px",
          flexWrap: "wrap",
        }}
      >
        {!isMobile && canExport && (
          <Button onClick={handleExportData} startIcon={<FileDownloadIcon />}>
            Export All Data
          </Button>
        )}
        {/* <Button
          onClick={() =>
            handleExportRows(table.getPrePaginationRowModel().rows)
          }
          startIcon={<FileDownloadIcon />}
        >
          Export All Rows
        </Button>
        <Button
          onClick={() => handleExportRows(table.getRowModel().rows)}
          startIcon={<FileDownloadIcon />}
        >
          Export Page Rows
        </Button> */}
        {!isMobile && canExport && (
          <Button
            disabled={
              !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
            }
            onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
            startIcon={<FileDownloadIcon />}
          >
            Export Selected Rows
          </Button>
        )}

        {/* this is only for month and year selector in partner Invoice  */}
        {showMonthYearPicker && (
          <MonthYearPicker onChange={handleMonthYearChange} />
        )}
        {/* // <MonthYearPicker onChange={handleDateChange} /> */}
      </Box>
    ),
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ✅ Mobile screen check

  return (
    // <ThemeProvider theme={darkTheme}>
    <>
      {/* */}
      <MaterialReactTable table={table} />
    </>
    // </ThemeProvider>
  );
};

export default NotificationTable;
